module.exports = "https://redage.akamaized.net/src/views/fractions/war/map/map.jpg";